/* Constants that do not request changes on a per-site basis. */
const constants = {
    SENDLISTGET: "SENDLISTGET",
    SENDGET: "SENDGET",
    SENDPOST: "SENDPOST",
    VERSIONGET: "VERSIONGET",
    USERLOCALGET: "USERLOCALGET",
    CURRENTSENDUSER: "CURRENTSENDUSER",
    TOKENCHECKGET: "TOKENCHECKGET",
    LOGOUTANDTOKENDESTROY: "LOGOUTANDTOKENDESTROY",
    LOGINANDTOKENGET: "LOGINANDTOKENGET",
    CENDINFO: "CENDINFO",
    TICKLE: "TICKLE",
    POSTUPDATE: "POSTUPDATE",
    MESSAGESTATUS: "MESSAGESTATUS",
}

export default constants


// WEBPACK FOOTER //
// ./src/Constants.js